import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ChangeServiceRoutingModule } from './change-service-routing.module';
import { ChangeserviceComponent } from './components/changeservice/changeservice.component';
import { ChangeservicesStickyFooterComponent } from './components/changeservices-sticky-footer/changeservices-sticky-footer.component';
import { ReviewchangeserviceComponent } from './components/reviewchangeservice/reviewchangeservice.component';
import { ChangeservicesConfirmationComponent } from './components/changeservices-confirmation/changeservices-confirmation.component';
import { ScamInfoComponent } from './components/scam-info/scam-info.component';
import { SharedModule } from '../shared/shared.module';
import { ServiceFilterPipe } from './pipes/service-filter.pipe';
import { ChangeServiceBulkSelectionComponent } from './components/change-service-bulk-selection/change-service-bulk-selection.component';

const declarations = [
  ChangeserviceComponent,
  ChangeservicesStickyFooterComponent,
  ReviewchangeserviceComponent,
  ChangeservicesConfirmationComponent,
  ScamInfoComponent,
  ServiceFilterPipe,
  ChangeServiceBulkSelectionComponent,
]
@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        ChangeServiceRoutingModule
    ],
    declarations: [
        ...declarations,
    ]
})
export class ChangeServiceModule {
  constructor() {
    console.log('change service module loaded');
  }
}
